function setMinicartHeight(header) {
    var minicartContent = document.getElementById('mini-cart-contents');
    var minicartHeight = window.innerHeight - header.offsetHeight;
    minicartContent.style.height = minicartHeight + 'px';
    minicartContent.style.top = header.offsetHeight;
}

export function customScripts() {
    if (document.getElementById('site-wrap')) {
        document.getElementById('site-wrap').classList.add('loaded');
    }

    if (document.getElementsByClassName('dropdown')) {
        let dropdowns = document.getElementsByClassName('dropdown');
        Array.from(dropdowns).forEach(item => {
            let menu = item.querySelector('.dropdown-menu');
            item.setAttribute('tabindex', 0);
            item.addEventListener('click', event => {
                menu.classList.toggle('show');
            });
            item.addEventListener('blur', event => {
                let target =
                    event.relatedTarget != null
                        ? event.relatedTarget.parentElement.classList
                        : null;

                if (target != 'dropdown-item') menu.classList.remove('show');
            });
        });
    }

    // main-content
    if (document.getElementById('header')) {
        var header = document.getElementById('header');
        document.querySelector('main').style.marginTop =
            header.clientHeight - 1 + 'px';
        window.addEventListener('resize', function () {
            document.querySelector('main').style.marginTop =
                header.clientHeight - 1 + 'px';
        });
    }

    if (document.getElementById('mini-cart-contents')) {
        setMinicartHeight(header);
        window.addEventListener('resize', function () {
            setMinicartHeight(header);
        });
    }

    if (document.getElementById('navbar')) {
        var navbar = document.getElementById('navbar');
        document.addEventListener('click', function (event) {
            if (
                !navbar.contains(event.target) &&
                !event.target.classList.contains('navbar__link')
            ) {
                Array.from(
                    document.getElementsByClassName('navbar__menu'),
                ).forEach(el => el.classList.remove('navbar__menu--show'));
                document.body.classList.remove('no-scroll');
            } 
        });
    }

    if (document.getElementById('mini-cart-contents')) {
        var miniCartButton = document.getElementById('miniCart');
        var miniCart = document.getElementById('mini-cart-contents');
        var miniCartClose = document.getElementById('cart-close-button');

        document.addEventListener('click', function (event) {
            if (
                !miniCartButton.contains(event.target) ||
                miniCartClose.contains(event.target)
            ) {
                miniCart.classList.add('cart__info--hidden');
            } else {
                miniCart.classList.remove('cart__info--hidden');
            }
        });
    }

    if (document.getElementById('testfreaks-badge')) {
        const links = document
            .getElementById('testfreaks-badge')
            .addEventListener('click', clickHandler);

        function clickHandler(e) {
            e.preventDefault();
            const href = this.getAttribute('href');
            const offsetTop = document.querySelector(href).offsetTop;
            scroll({
                top: offsetTop,
                behavior: 'smooth',
            });
        }
    }

    if (document.getElementById('my-pages-menu')) {
        let menuItems = document.querySelectorAll('#my-pages-menu li');
        let startPage = document.getElementsByClassName('mypage-start')[0];
        for (let i = 0; i < menuItems.length; i++) {
            menuItems[i].addEventListener('click', function () {
                if (this.classList.contains('active')) return;

                if (!startPage.classList.contains('hidden'))
                    startPage.classList.add('hidden');

                let activeMenuItems = document.querySelectorAll(
                    '#my-pages-menu li.active',
                );
                let activeTabs = document.querySelectorAll(
                    '#my-pages-grid-content .tab:not(.hidden)',
                );

                for (let x = 0; x < activeMenuItems.length; x++)
                    activeMenuItems[x].classList.remove('active');

                for (let x = 0; x < activeTabs.length; x++)
                    activeTabs[x].classList.add('hidden');

                let item = document.querySelector(`div.${this.className}`);
                item.classList.toggle('hidden');
                this.classList.toggle('active');
            });
        }

        let menuHeaders = document.querySelectorAll('.menu-header');
        for (let x = 0; x < menuHeaders.length; x++)
            menuHeaders[x].addEventListener('click', e => {
                e.stopPropagation();
                window.location.reload();
            });
    }

    if (document.getElementById('my-pages-menu-collapsible')) {
        let toggle = document.getElementById('my-pages-menu-collapsible');

        toggle.addEventListener('click', function () {
            this.classList.toggle('active');
            document.getElementById('my-pages-menu').classList.toggle('active');
        });
    }
}
